import React, {Component} from "react";
import {injectIntl} from "react-intl";
import {Col, Row} from "antd";
import './Fleetback.css'
import Amount from "../../common/format/Amount";

class FleetbackPayment extends Component {

  render() {
    const {intl:{formatMessage}, paymentSummary} = this.props;

    return (
      <React.Fragment>
        <Row>
          <Col offset={8} span={8} className={"fc-rtl"}>{formatMessage({id:'exclude.vat'})}</Col>
          <Col span={8} className={"fc-rtl"}>{formatMessage({id:'include.vat'})}</Col>
        </Row>
        <Row>
          <Col span={8} className={"fc-rtl"}>{formatMessage({id:'fleetback.total-accepted'})}:</Col>
          <Col span={8} className={"fc-rtl"}><Amount amount={paymentSummary.worksAcceptedTotal}/></Col>
          <Col span={8} className={"fc-rtl"}><Amount amount={paymentSummary.worksAcceptedTotalVatIncl}/></Col>
        </Row>
        <Row>
          <Col span={8} className={"fc-rtl"}>{formatMessage({id:'fleetback.total-done'})}:</Col>
          <Col span={8} className={"fc-rtl"}><Amount amount={paymentSummary.worksDoneTotal}/></Col>
          <Col span={8} className={"fc-rtl"}><Amount amount={paymentSummary.worksDoneTotalVatIncl}/></Col>
        </Row>
        <hr/>
        <Row>
          <Col span={8} className={"fc-rtl"}>{formatMessage({id:'fleetback.total-billable'})}:</Col>
          <Col span={8} className={"fc-rtl"}><Amount amount={paymentSummary.billableTotal}/></Col>
          <Col span={8} className={"fc-rtl"}><Amount amount={paymentSummary.billableTotalVatIncl}/></Col>
        </Row>
        <Row>
          <Col span={8} className={"fc-rtl"}>{formatMessage({id:'fleetback.total-paid'})}:</Col>
          <Col offset={8} span={8} className={"fc-rtl"}><Amount amount={paymentSummary.paidTotalVatIncl}/></Col>
        </Row>
        <hr/>
        <Row>
          <Col span={8} className={"fc-rtl"}>{formatMessage({id:'fleetback.total-balance'})}:</Col>
          <Col offset={8}  span={8} className={"fc-rtl"}><Amount amount={paymentSummary.payableTotalVatIncl}/></Col>
        </Row>

      </React.Fragment>
    );
  }
}

export default injectIntl(FleetbackPayment);
